import { fork } from "redux-saga/effects";

import shoppingSaga from "./shopping";
import divisionsSaga from "./divisions";

export default function* rootSaga() {
  yield fork(shoppingSaga);
  yield fork(divisionsSaga);
}
